import { maskitoDateOptionsGenerator } from '@maskito/kit';

export default maskitoDateOptionsGenerator({ mode: 'dd/mm/yyyy', separator: '/', max: new Date() });
